/***
 * @module AppModule
 */

import {BrowserModule} from '@angular/platform-browser';
import {LOCALE_ID, NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {ServiceWorkerModule} from '@angular/service-worker';
import {environment} from '../environments/environment';
import {NgProgressModule} from 'ngx-progressbar';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ToastrModule} from 'ngx-toastr';
import {NgProgressRouterModule} from 'ngx-progressbar/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslocoRootModule} from './transloco-root.module';
import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {SharedModule} from 'shared/lib/shared.module';
import {sharedConfig} from 'app/shared.config';
import {LayoutModule} from '../../projects/layout/src/lib/layout.module';
import {RouterModule} from '@angular/router';
import '@angular/common/locales/global/da';
import {StoreModule} from '@ngrx/store';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {EffectsModule} from '@ngrx/effects';
import {UserEffects} from 'app/_effects/user.effects';
import * as fromUser from 'app/_reducers/user.reducer';
import * as fromModal from 'app/_reducers/modal.reducer';
import {routerReducer, StoreRouterConnectingModule} from '@ngrx/router-store';
import {NgProgressHttpModule} from 'ngx-progressbar/http';
import {EmptyComponent} from 'app/empty.component';
import {QUILL_MODULES} from 'shared/quill-config';
import {NavigationEffects} from 'app/_effects/navigation.effects';
import {QuillModule} from 'ngx-quill';
import {FooterComponentModule} from '../../projects/layout/src/lib/layout/footer/footer.component';
import {ModalDirective} from 'app/modal/modal.directive';
import {PRIMARY_SYMBOL_COLOR} from 'shared/magic';
import {NgSelectModule} from '@ng-select/ng-select';
import {SettingsModule} from '../../projects/settings/src/lib/settings.module';
import {AuthInterceptor} from 'shared/_interceptor/auth.interceptor';

@NgModule({
	declarations: [
		AppComponent,
		ModalDirective,
		EmptyComponent
	],
	imports: [
		BrowserModule.withServerTransition({appId: 'serverApp'}),
		AppRoutingModule,
		HttpClientModule,
		LayoutModule,
		BrowserAnimationsModule, // required animations module
		ToastrModule.forRoot(),
		NgProgressModule.withConfig({color: PRIMARY_SYMBOL_COLOR, thick: true}),
		NgProgressRouterModule,
		NgProgressHttpModule,
		LayoutModule,
		ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.production}),
		ReactiveFormsModule,
		FormsModule,
		TranslocoRootModule,
		NgbDropdownModule,
		SharedModule.forRoot(sharedConfig),
		RouterModule,
		StoreModule.forRoot({
			router: routerReducer,
			[fromModal.modalFeatureKey]: fromModal.reducer,
			[fromUser.userFeatureKey]: fromUser.reducer
		}, { runtimeChecks: { strictStateImmutability: true, strictActionImmutability: true } }),
		EffectsModule.forRoot([UserEffects, NavigationEffects]),
		StoreDevtoolsModule.instrument({ maxAge: 50, logOnly: environment.production }),
		StoreRouterConnectingModule.forRoot(),
		ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
		QuillModule.forRoot({
			modules: QUILL_MODULES
		}),
		FooterComponentModule,
		NgSelectModule,
		SettingsModule
	],
	providers: [
		{provide: LOCALE_ID, useValue: 'da-DK'},
		{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
	],
	bootstrap: [AppComponent]
})
export class AppModule {
}
